// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\App\Users\Tenant\PermissionDefinitions\Enums\TenantPermissionDefinitionField
// Generated on: <normalized>

export enum TenantPermissionDefinitionField {
  DB_TABLE = 'tenant_permission_definitions',
  DB_IDENTIFIER = 'permissionDefinitionGUID',
  NAME = 'name',
  DESCRIPTION = 'description',
  OPERATION_KEY = 'operationKey',
  IS_ACTIVE = 'isActive',
  CREATED_BY_USER_GUID = 'createdByUserGUID',
}

export const TenantPermissionDefinitionFieldWritableFields = ["name", "description", "operationKey", "isActive"] as const;

export const TenantPermissionDefinitionFieldGetEncryptionFields = [] as const;

export const TenantPermissionDefinitionFieldCases = ["tenant_permission_definitions", "permissionDefinitionGUID", "name", "description", "operationKey", "isActive", "createdByUserGUID"] as const;
